import React, { useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { GaugeMeter } from 'sharedComponents/gaugeMeter';
import { RootState } from 'store/store';
import { logoSvg, poweredByLogo } from 'assets/images';
import { getScoreByPriority } from '../CreditHelper';

const Step4: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  const { softAssesmentData } = useSelector((state: RootState) => state.creditScoreStore);

  // React Hook Form Trigger
  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;
    onNext?.(5);
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <div className='csc-screens__form-col shadow csc-screens__form-col--credit-snapshot'>
      <div className='logo'>
        <img src={logoSvg} alt='Dabadu' className='img-fluid' />
      </div>
      <div className='csc-screens__form-col__top'>
        <h3 className='csc-screens__form-col__title text-center'>{t('stepperForm.heading5')}</h3>
      </div>
      <div className='csc-screens__form-col__middle'>
        <GaugeMeter value={getScoreByPriority(softAssesmentData?.creditScore || [])} />
        <div className='csc-screens__cr-box'>
          <p className='data-provide-by'>
            {t('stepperFormCredit.txt1')} <img src={poweredByLogo} alt='EquiFax' /> Canada
          </p>
          <p className='data-consent'>{t('stepperFormCredit.txt2')}</p>
          <div className='cr-box-status-box'>
            <h4 className='cr-box-status-box__title'>{t('stepperFormCredit.txt3')}</h4>
            <p>{t('stepperFormCredit.txt4')}</p>
            {/* <p className='cr-box-status-box__status'>Likelihood of Approval: <span className='success'>Probable</span></p> */}
            {/* <p className='cr-box-status-box__status'>Likelihood of Approval: <span className='danger'>Probable</span></p> */}
            {/* <CommonButton
              type={'button'}
              label={t('Complete My Application')}
              variant='contained'
            /> */}
          </div>
        </div>
        {/* <div className='lenders-offer-text'>
          <h4 className='lenders-offer-text__title'>{t('stepperForm.greatNews')}</h4>
          <p>{t('stepperForm.creditNote')}</p>
          <p>
            {t('stepperForm.txt1')}
            <span className='lenders-offer-text__approval'>{t('stepperForm.veryLikely')}</span>
          </p>
          </div> */}
      </div>
    </div>
  );
};

const StepperForm4 = React.forwardRef(Step4);

export default StepperForm4;
